<template>
  <div class="allApointments">
    <van-sticky>
      <div class="header">
        <div class="headerIcon">
          <van-icon name="arrow-left" color="#fff" @click="returnIndex" />
          <van-search v-model="value" placeholder="查找" @input="searchInput" />
        </div>
      </div>
      <van-tabs v-model="active" class="tabAll" @click="activeChange">
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="待完成" name="3"></van-tab>
        <van-tab title="已完成" name="2"></van-tab>
        <van-tab title="已取消" name="1"></van-tab>
      </van-tabs>
    </van-sticky>
    <div v-if="tableData">
      <div class="allProject" v-for="(item, index) in tableData" :key="index">
        <div @click="enterDetail(item)">
          <div class="facialName">
            <div class="facialNext">
              <img src="../../assets/img/my-finish.png" alt="" style="width:1.43rem;margin-right:.3rem">
              <span class="facial">{{ item.projectName }}</span>
            </div>
            <div class="toBeFinish" v-if="item.operationStatus == 3">待完成</div>
            <div class="schedule" v-if="item.operationStatus == 2">已完成</div>
            <div class="cancel" v-if="item.operationStatus == 1">已取消</div>
          </div>
          <div class="outpatient">
            <van-icon name="clock-o" color="#ABABB3" size="1.25rem;margin-right:.5rem" />
            <span>预约门诊时间：</span>
            <span class="outName">{{ item.appointmentTime }}</span>
          </div>
          <div class="outpatient">
            <van-icon name="user-circle-o" color="#ABABB3" size="1.25rem;margin-right:.5rem" />
            <span>{{ item.customerName }}：</span>
            <!-- <span class="outName">{{item.mobile}}</span> -->
            <span v-if="status == 1">{{ item.mobile.replace(item.mobile.substr(0, 7), '*******') }}</span>
            <span v-if="status == 0">{{ item.mobile }}</span>
          </div>
          <div class="outpatient">
            <van-icon name="user-circle-o" color="#ABABB3" size="1.25rem;margin-right:.5rem" />
            <span>操作人：</span>
            <span class="outName">{{ item.doctorName }}</span>
          </div>
        </div>
        <div class="split_line"></div>
        <div class="concat" v-show="flag">
          <div class="contactClients" @click="callPhone(item.mobile)">联系客户</div>
          <div class="cancelAppointment" v-if="item.operationStatus == 3" @click="sureFinish(item, 1)">取消预约</div>
          <!-- <div class="cancelAppointment" v-if="item.operationStatus==3" @click="sureFinish(item,2)">确认完成</div> -->
          <div class="cancelAppointment" v-if="item.operationStatus == 3" @click="handEdit(item)">编辑</div>
        </div>
      </div>
    </div>
    <div v-if="tableData.length == 0">
      <div class="indexWhite">
        <img src="../../assets/img/my-white.png" alt="">
      </div>
      <div class="whitePart">暂无相关预约</div>
    </div>
  </div>
</template>
<script>
import {
  findAppointmentList,
  updateAppointmentStatusById
} from "@/axios/api";
import {
  Toast
} from 'vant';
export default {
  data() {
    return {
      active: '0',
      value: '',
      tableData: [],
      flag: true,
      status: '',
      doctorNo: '',
      scrollTop: ''
    }
  },
  created() {
    this.empId = JSON.parse(localStorage.getItem('userInfo')).empId,
      this.status = JSON.parse(localStorage.getItem('userInfo')).status
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    // console.log(this.empId)
    console.log(this.$route.params.val)
    if (this.$route.params.val) {
      if (this.$route.params.val == 3) {
        this.active = "3"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 2) {
        this.active = "2"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 1) {
        this.active = "1"
        this.appointmentList(this.active, '');
      } else if (this.$route.params.val == 4) {
        this.appointmentList();
      }
    } else if (this.$route.params.val == undefined) {
      this.appointmentList()
    }
    console.log('this.status')
    console.log(this.status)
    if (this.status == 1) {
      this.flag = false
    } else if (this.status == 0) {
      this.flag = true
    }

  },
  methods: {
    returnIndex() {
      this.$router.push("/aboutUs")
    },
    // 编辑当条信息
    handEdit(row) {
      console.log(row)
      this.$router.replace({
        name: "editAppointment",
        query: row,
      });
    },
    // 查询预约列表
    appointmentList(
      operationStatus,
      name
    ) {
      findAppointmentList({
        operationStatus: operationStatus,
        userId: this.empId,
        name: name,
        userStatus: this.status,
        doctorNo: this.doctorNo,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
      })
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.tableData = res.data;
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    activeChange(val, title) {
      this.appointmentList(val, this.value);
    },
    // 点击进入详情页
    enterDetail(item) {
      console.log(item);
      this.$router.push({
        name: "mineDetail",
        query: item,
      });
    },
    // 取消预约
    sureFinish(row, val) {
      // 2-确认完成,1-取消
      console.log(row)
      console.log(val)
      let data = {
        appointmentId: row.appointmentId,
        operationStatus: val,
        projectType: row.projectType
      }
      updateAppointmentStatusById(data)
        .then((res) => {
          console.log(res.data);
          if (res.result == true) {
            this.appointmentList(this.active, '');
            Toast.success('状态修改成功');
          } else {
            Toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 联系客户
    callPhone(phoneNumber) {
      console.log(phoneNumber)
      window.location.href = 'tel://' + phoneNumber
    },
    // 关键字查询
    searchInput(val) {
      this.appointmentList(this.active, this.value)
    }
  },
  //A>B>C  A>B刷新 C>B不刷新
  beforeRouteLeave(to, from, next) {
    // console.log(to.name)
    if (to.name === 'mineDetail' || to.name === 'editAppointment') {
      from.meta.keepAlive = true;
      // console.log(from.meta.keepAlive)
    } else {
      from.meta.keepAlive = false;
      from.meta.ifDoFresh = true;
    }
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop
    document.documentElement.scrollTop || document.body.scrollTop
    next(); //不可缺少
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // document.body.scrollTop = vm.scrollTop
      window.scrollTo(0, vm.scrollTop);
    })
    next()
  },
  activated() {
    //开启了keepAlive:true后再次进入,这样就能得到最新数据
    if (this.$route.meta.ifDoFresh) {
      //重置ifDoFresh
      this.$route.meta.ifDoFresh = false;
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      this.status = JSON.parse(localStorage.getItem('userInfo')).status
      this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
      //获取列表数据方法第一参数为是否重置搜索条件和页数
      this.appointmentList(this.active, "");
      console.log(this.active)
    }
  },
}

</script>
<style scoped>
@import "../../assets/css/allAppointments.css";
</style>



// WEBPACK FOOTER //
// src/components/page/allAppointments.vue